import {PaymentMethodType} from '@/constants/payment-method-type'

export const paymentMethodTabs = [
    {
        key: PaymentMethodType.applepay
    },
    {
        key: PaymentMethodType.googlepay
    },
    {
        key: PaymentMethodType.paypal
    },
    {
        key: PaymentMethodType.klarna
    }
]
